export const en = {
    "Total": "Total",
    "Items": "items",
    "Item": "item"
}